import { EntityTypes, SubscriptionGroup, SubscriptionStatus, SubscriptionTypes } from "./enums";

export interface Subscription {
    subscriptionId: string;
    entityType: EntityTypes;
    subscriptionType: SubscriptionTypes;
    subscriptionGroup: SubscriptionGroup;
    subscriptionCost: number;
}

export interface DiscountCode {
    discountId: string;
    entityType: EntityTypes;
    code: string;
    discount: number;
    expirationDate: number;
}

export interface SupplierSubscription {
    expiration: number;
    subscriptionType: SubscriptionTypes;
    subscriptionStatus: SubscriptionStatus;
    lastUpdated: number;
    created: number;
}

export const SupplierSubscriptionSchema = {
    type: 'object',
    properties: {
        expiration: { type: 'number' },
        subscriptionType: { type: 'string', enum: Object.values(SubscriptionTypes) },
        subscriptionStatus: { type: 'string', enum: Object.values(SubscriptionStatus) },
        lastUpdated: { type: 'number' },
        created: { type: 'number' },
    },
    required: ['expiration', 'subscriptionType', 'subscriptionStatus', 'lastUpdated', 'created'],
    additionalProperties: false,
};